import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import CompanyPage from "./pages/CompanyPage";
import ImpressumDatenschutz from "./pages/ImpressumCompany";
import Contact from "./pages/Contact";
import AdminInquiries from "./pages/AdminInquiries";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/admin/anfragen" element={<AdminInquiries />} />
            <Route path="/impressum/:companyId" element={<ImpressumDatenschutz />} />
            <Route path="/impressum" element={<ImpressumDatenschutz />} />
            <Route path="/datenschutz" element={<ImpressumDatenschutz />} />
            <Route path="/:companyId" element={<CompanyPage />} />
          </Routes>
          <Footer />
          <CookieConsent />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
